import React from 'react';

/**
 * Breed Weight Output component
 */
const BreedWeightOutput = (props) => (
  <div className="nppe2-fc-breed-weight-output">
    <img className="img-responsive" src={props.dataBreed.image} alt={props.dataBreed.size}/>

    {(props.dataBreed.minWeight != null && props.dataBreed.maxWeight != null) && 
      <p>{props.dataBreed.minWeight}{props.dataBreed.weightSuffix} - {props.dataBreed.maxWeight}{props.dataBreed.weightSuffix}</p>
    }
  </div>
);

export default BreedWeightOutput;
